import {IUser} from "./edit/EditUser";

export const initialUserObj: IUser = {
    _id: "",
    name: "",
    email: "",
    metadataMulti: []
}